import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading placeholder for the template edit page, rendered by
 * `TemplateEditPage` while `useTemplate` is pending. A header row plus a body
 * card (heading + field rows + footer actions) so the page lines up with the
 * loaded builder rather than popping from a single grey box.
 */
export function TemplateSkeleton() {
  return (
    <div className="mx-auto w-full max-w-5xl space-y-4" data-skeleton-wizard>
      {/* Breadcrumb row: back button · separator · name */}
      <div className="flex items-center gap-3 pb-4">
        <Skeleton className="h-8 w-36" />
        <Skeleton className="h-4 w-4" />
        <Skeleton className="h-5 w-48" />
      </div>

      {/* Stepper row — same balanced grid as the wizard so the steps sit
          centred, with the auto-save indicator placeholder on the right. */}
      <div className="grid grid-cols-[1fr_auto_1fr] items-center">
        <div />
        <div className="flex items-center gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} data-skeleton-step className="h-8 w-24 rounded-full" />
          ))}
        </div>
        <Skeleton className="h-5 w-20 justify-self-end" />
      </div>

      {/* Body card — same chrome as the wizard's step container. */}
      <div className="bg-card space-y-6 rounded-lg border p-6">
        <Skeleton className="h-6 w-40" />
        <div className="space-y-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} data-skeleton-field className="space-y-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-10 w-full" />
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-3 pt-2">
          <Skeleton className="h-10 w-24" />
          <Skeleton className="h-10 w-28" />
        </div>
      </div>
    </div>
  );
}
